import { render, staticRenderFns } from "./peixunTxt.vue?vue&type=template&id=2cf4377e&scoped=true"
import script from "./peixunTxt.vue?vue&type=script&lang=js"
export * from "./peixunTxt.vue?vue&type=script&lang=js"
import style0 from "./peixunTxt.vue?vue&type=style&index=0&id=2cf4377e&prod&lang=scss"
import style1 from "./peixunTxt.vue?vue&type=style&index=1&id=2cf4377e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4377e",
  null
  
)

export default component.exports